var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAurora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#70D44B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_555_2751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9971 5.84024C11.2241 5.83952 11.4469 5.90238 11.6401 6.02172C11.8333 6.14106 11.9892 6.31211 12.0901 6.51549L15.5275 13.3902C15.6207 13.5765 15.6648 13.7836 15.6555 13.9918C15.6462 14.1999 15.5838 14.4023 15.4742 14.5795C15.3647 14.7568 15.2117 14.9031 15.0297 15.0046C14.8477 15.1061 14.6428 15.1593 14.4344 15.1593H7.55972C7.35135 15.1593 7.14643 15.1061 6.96444 15.0046C6.78245 14.9031 6.62942 14.7568 6.51989 14.5795C6.41037 14.4023 6.34798 14.1999 6.33866 13.9918C6.32934 13.7836 6.37339 13.5765 6.46664 13.3902L9.90399 6.51549C10.005 6.31211 10.1609 6.14106 10.3541 6.02172C10.5473 5.90238 10.77 5.83952 10.9971 5.84024ZM10.9971 5C10.6141 4.99996 10.2387 5.10655 9.91285 5.30784C9.58704 5.50913 9.32371 5.79716 9.15236 6.13967L5.71501 13.0144C5.55769 13.3288 5.48339 13.6783 5.49914 14.0295C5.5149 14.3808 5.6202 14.7222 5.80503 15.0213C5.98987 15.3204 6.24811 15.5673 6.55522 15.7385C6.86233 15.9097 7.20811 15.9996 7.55972 15.9995H14.4344C14.786 15.9996 15.1318 15.9097 15.4389 15.7385C15.746 15.5673 16.0043 15.3204 16.1891 15.0213C16.3739 14.7222 16.4792 14.3808 16.495 14.0295C16.5108 13.6783 16.4364 13.3288 16.2791 13.0144L12.8418 6.13967C12.6704 5.79716 12.4071 5.50913 12.0813 5.30784C11.7555 5.10655 11.38 4.99996 10.9971 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555_2751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(5.5 5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAurora);
export default __webpack_public_path__ + "static/media/aurora.a92652138838727a8f3e2b2cbbe55702.svg";
export { ForwardRef as ReactComponent };